<app-mb-field preicon pill fullwidth>
    <i class="fas fa-search"></i>
    <input type="text" placeholder="Buscar..." [value]="query" (input)="onQueryChange($any($event.target).value)">
</app-mb-field>
@if (groups.length > 0) {
  <div class="search-results">
    @for (group of groups; track group.label) {
      <section class="result-group">
        <h6>{{ group.label }}</h6>
        <ul>
          @for (option of group.options; track option.key) {
            <li>
              <button type="button" (click)="onSelectResult(option.key)">{{ option.label }}</button>
            </li>
          }
        </ul>
      </section>
    }
  </div>
}
@if (query && groups.length === 0) {
  <div class="search-results empty">
    <p>Sin resultados</p>
  </div>
}
